import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
});

// Attach token to every request if available
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("admin_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Global 401 interceptor — redirect to login state if session expired
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401 && !error.config?.url?.includes("/auth/login")) {
            // Token expired or invalid — clear and trigger auth reset
            localStorage.removeItem("admin_token");
            window.dispatchEvent(new CustomEvent("auth:expired"));
        }
        return Promise.reject(error);
    }
);

export function apiError(e, fallback = "Something went wrong. Please try again.") {
    const detail = e?.response?.data?.detail;
    if (detail == null) return e?.message || fallback;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).filter(Boolean).join(" ");
    }
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

// Fire-and-forget click analytics (call / whatsapp) — never blocks the UI
export function trackClick(event, source) {
    api.post("/api/track-click", { event, source }).catch(() => {});
}

export default api;
